import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { Creators as Actions, Types } from "ducks/Cte";
import { Creators as ActionsGeral } from "ducks/Geral";
import api from "../api/api";
import DadosNotasCte from "Dados/DadosNotasCte.js";
import NotasCte from "Dados/NotasCte.js";
import PesquisaCte from "Dados/PesquisaCte.js";

let cteMensagem = "";

const buscarNotasCteRequisicao = async (formBusca) =>
    api
        .get(
            `/api/cte/filtros/getnotascte/
	${formBusca.tipoServico}/
	${formBusca.dataInicio.format("DDMMYYYY")}/
	${formBusca.dataFim.format("DDMMYYYY")}/
	${formBusca.empresa}/
	${formBusca.transportadora}/
	${formBusca.modoPesquisa}`
            // {
            // tipo_servico: formBusca.tipoServico,
            // dataInicio: formBusca.dataInicio.format('DDMMYYYY'),
            // dataFim: formBusca.dataFim.format('DDMMYYYY'),
            // cnpj_emitente_nota: formBusca.empresa,
            // cnpj_transp_nota: formBusca.transportadora,
            // modo_pesquisa: formBusca.modoPesquisa

            // }/
        )
        .then((notasCteData) => notasCteData)
        .catch((error) => error);

const buscarCteRequisicao = async () =>
    api
        .get(`/api/cte/filtros/getcte`)
        .then((CteData) => CteData)
        .catch((error) => error);

const buscarEstadosRequisicao = async () =>
    api
        .get(`/api/cte/ibge/cidades/`)
        .then((buscarEstados) => buscarEstados)
        .catch((error) => error);

const buscarTransportadorasRequisicao = async () =>
    api
        .get(`/api/empresa/pesquisar`)
        .then((buscarTransportadoras) => buscarTransportadoras)
        .catch((error) => error);

const buscarDistribuidorasRequisicao = async () =>
    api
        .get(`/api/empresa/pesquisar`)
        .then((buscarDistribuidoras) => buscarDistribuidoras)
        .catch((error) => error);

const buscarCidadeRequisicao = async (estado) =>
    api
        .post("/api/destinatarios/busca/cidade/")
        .then((destinatariosData) => destinatariosData)
        .catch((error) => error);

//---------------------------------------------------------
// const EditarCteRequisicao = async (DadosNotasCte) =>
//      api.post('/api/destinatarios/busca/cidade/').then((destinatariosData) => destinatariosData).catch((error) => error);

// const buscarNotasRequisicao = async (DadosNotasCte) =>
//      api.post('/api/destinatarios/busca/cidade/').then((destinatariosData) => destinatariosData).catch((error) => error);

// const buscarNotasRomaneiosRequisicao = async (dados) =>
// 	api.get('/api/notas/busca/porchave', dados).then((buscarNotas) => buscarNotas).catch((error) => error);

//---------------------------------------------------------
const buscarDistTranfRequisicao = async (dados) =>
    api
        .get("api/cte/buscar/remdest/", dados)
        .then((buscarCte) => buscarCte)
        .catch((error) => error);

const gerarCteRequisicao = async (dados) =>
    api
        .post("api/cte/automatico/gerar/", dados)
        .then((buscarCte) => buscarCte)
        .catch((error) => error);

function* buscarNotasCte({ payload }) {
    const { formBusca } = payload;
    cteMensagem = "";
    let notasCteData = [];

    try {
        const response = yield call(buscarNotasCteRequisicao, formBusca);
        if (response.ok) {
            notasCteData = response.data.map((NotasCte) => ({
                numero: NotasCte.numero_nota ? NotasCte.numero_nota : "",
                usuarioEmissao: NotasCte.chave_nota ? NotasCte.chave_nota : "",
                dataEmissao: NotasCte.serie_nota ? NotasCte.serie_nota : "",
                tipoCte: NotasCte.valor_frete ? NotasCte.valor_frete : "",
                chaveCte: NotasCte.valor_mercadoria
                    ? NotasCte.valor_mercadoria
                    : "",
                quantidade: NotasCte._id ? NotasCte._id : "",
                status: NotasCte.modo_pesquisa ? NotasCte.modo_pesquisa : "",
                _id: NotasCte._id ? NotasCte._id : "",
            }));

            yield put(Actions.buscarNotasCteSucesso(notasCteData));
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        cteMensagem = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                cteMensagem = "Ocorreu um erro interno.Tente novamente";
            }
            yield put(ActionsGeral.mostrarMensagem(cteMensagem));
        }
    } catch (error) {
        console.log(error);
        yield put(
            ActionsGeral.mostrarMensagem(`Erro Buscar Motoristas:${error}`)
        );
    }
}

function* buscarTransportadorasCte({ payload }) {
    cteMensagem = "";
    let dadosEmpresa = [];
    try {
        const response = yield call(buscarTransportadorasRequisicao);
        if (response.ok) {
            let dadosTransportadoras = response.data.map((empresas) => ({
                nome: empresas.nome_empresa ? empresas.nome_empresa : "",
                cnpj: empresas.cnpj_empresa ? empresas.cnpj_empresa : "",
            }));
            yield put(
                Actions.buscarTransportadorasCteSucesso(dadosTransportadoras)
            );
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        cteMensagem = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                cteMensagem = "Ocorreu um erro interno.Tente novamente";
            }
            yield put(ActionsGeral.mostrarMensagem(cteMensagem));
        }
    } catch (error) {
        console.log(error);
        yield put(
            ActionsGeral.mostrarMensagem(`Erro Buscar Motoristas:${error}`)
        );
    }
}

function* buscarDistribuidorasCte({ payload }) {
    cteMensagem = "";
    let dadosDistribuidoras = [];
    try {
        const response = yield call(buscarDistribuidorasRequisicao);
        if (response.ok) {
            dadosDistribuidoras = response.data.map((Distribuidoras) => ({
                nome: Distribuidoras.nome_empresa
                    ? Distribuidoras.nome_empresa
                    : "",
                cnpj: Distribuidoras.cnpj_empresa
                    ? Distribuidoras.cnpj_empresa
                    : "",
            }));
            yield put(
                Actions.buscarDistribuidorasCteSucesso(dadosDistribuidoras)
            );
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        cteMensagem = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                cteMensagem = "Ocorreu um erro interno.Tente novamente";
            }
            yield put(ActionsGeral.mostrarMensagem(cteMensagem));
        }
    } catch (error) {
        console.log(error);
        yield put(
            ActionsGeral.mostrarMensagem(`Erro Buscar Motoristas:${error}`)
        );
    }
}

function* buscarEstadosCte({ payload }) {
    cteMensagem = "";
    let estadosDados = [];
    try {
        const response = yield call(buscarEstadosRequisicao);
        if (response.ok) {
            estadosDados = response.data;
            yield put(Actions.buscarEstadosCteSucesso(estadosDados));
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        cteMensagem = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                cteMensagem = "Ocorreu um erro interno.Tente novamente";
            }
            yield put(ActionsGeral.mostrarMensagem(cteMensagem));
        }
    } catch (error) {
        console.log(error);
        yield put(
            ActionsGeral.mostrarMensagem(`Erro Buscar Motoristas:${error}`)
        );
    }
}

function* buscarCte({ payload }) {
    cteMensagem = "";
    let CteData = [];

    try {
        const response = yield call(buscarCteRequisicao);
        if (response.ok) {
            // CteData = response.data;

            CteData = response.data.map((buscaCte) => ({
                numeroCte: buscaCte.numero_cte ? buscaCte.numero_cte : "",
                tipoCte: buscaCte.tipo_cte ? buscaCte.tipo_cte : "",
                tipoServico: buscaCte.tipo_servico ? buscaCte.tipo_servico : "",
                valorTotal: buscaCte.valor_total ? buscaCte.valor_total : "",
                statusCte: buscaCte.status_cte ? buscaCte.status_cte : "",
                quantidadeNotas: buscaCte.quantidade_notas
                    ? buscaCte.quantidade_notas
                    : "",
            }));

            yield put(Actions.buscarCteSucesso(CteData));
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        cteMensagem = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                cteMensagem = "Ocorreu um erro interno.Tente novamente";
            }
            yield put(ActionsGeral.mostrarMensagem(cteMensagem));
        }
    } catch (error) {
        console.log(error);
        yield put(
            ActionsGeral.mostrarMensagem(`Erro Buscar Motoristas:${error}`)
        );
    }
}
//----------------------------------------------------------------
//----------------------------------------------------------------
//----------------------------------------------------------------
//----------------------------------------------------------------
//----------------------------------------------------------------

function* listaGerarCte({ payload }) {
    const dados = payload;

    let distTransp = [];
    cteMensagem = "Error romaneios";
    const response = yield call(gerarCteRequisicao, dados);
    if (response.ok) {
        yield put(Actions.listaGerarCteSucesso(response.data));
    } else {
        if (response.data.hasOwnProperty("error")) {
            switch (response.data.error) {
                default:
                    cteMensagem = "Não foi possível gerar romaneios [205]";
                    break;
            }
        } else {
            cteMensagem = "Sem dados para exibir";
        }
        // yield put(Actions.setLoadGerarRomaneios({ loader: false }));
    }

    // yield put(Actions.setLoadGerarRomaneios({ loader: false }));
}

function* buscarDistTransp({ payload }) {
    // const cnpjEmitente = payload;

    const dadoss = {
        cnpjEmitente: "13593222000107",
        tipoCnpjPesquisa: "remetente",
    };

    let distTransp = [];
    cteMensagem = "Error romaneios";
    const response = yield call(buscarDistTranfRequisicao, dadoss);
    if (response.ok) {
        if (response.data.resultado) {
            distTransp = response.data.valor;
            yield put(Actions.buscarDistTranspSucesso(distTransp));
        }
    } else {
        if (response.data.hasOwnProperty("error")) {
            switch (response.data.error) {
                default:
                    cteMensagem = "Não foi possível gerar romaneios [205]";
                    break;
            }
        } else {
            cteMensagem = "Sem dados para exibir";
        }
        // yield put(Actions.setLoadGerarRomaneios({ loader: false }));
    }

    // yield put(Actions.setLoadGerarRomaneios({ loader: false }));
}

function* buscarNotas({ payload }) {
    const { cnpjEmpresa, formBipe } = payload;

    const dados = {
        cnpjTomador: cnpjEmpresa ? cnpjEmpresa : "",
        chaveNota: formBipe ? formBipe : "",
    };
    let buscarNotass = [];
    cteMensagem = "Error romaneios";
    const response = {}; //yield call(buscarNotasRequisicao, dados);
    if (response.ok) {
        if (response.data.resultado) {
            buscarNotass = response.data.valor;
            yield put(Actions.buscarNotasSucesso(buscarNotass));
        }
    } else {
        if (response.data.hasOwnProperty("error")) {
            switch (response.data.error) {
                default:
                    cteMensagem = "Não foi possível gerar romaneios [205]";
                    break;
            }
        } else {
            cteMensagem = "Sem dados para exibir";
        }
        // yield put(Actions.setLoadGerarRomaneios({ loader: false }));
    }

    // yield put(Actions.setLoadGerarRomaneios({ loader: false }));
}

function* editarCte({ payload }) {
    //console.log('chegou->', DadosNotasCte)
    // const { cnpjEmpresa } = payload;

    // const dados = {
    // 	cnpjTomador: cnpjEmpresa ? cnpjEmpresa : '',
    // 	chaveNota: formBipe ? formBipe : ''
    // };
    let buscarNotass = [];
    cteMensagem = "Error romaneios";
    // const response = yield call(buscarNotasRequisicao, dados);
    yield put(Actions.editarCteSucesso(DadosNotasCte));

    // if (response.ok) {
    // 	if (response.data.resultado) {
    // 		buscarNotass = response.data.valor;
    // 		yield put(Actions.editarCteSucesso(DadosNotasCte));
    // 	}
    // } else {
    // 	if (response.data.hasOwnProperty('error')) {
    // 		switch (response.data.error) {
    // 			default:
    // 			cteMensagem = 'Não foi possível gerar romaneios [205]';
    // 				break;
    // 		}
    // 	} else {
    // 		cteMensagem = 'Sem dados para exibir';
    // 	}
    // 	// yield put(Actions.setLoadGerarRomaneios({ loader: false }));
    // }

    // yield put(Actions.setLoadGerarRomaneios({ loader: false }));
}

function* incluirNotCte({ payload }) {
    //console.log('chegou->', DadosNotasCte)
    // const { cnpjEmpresa } = payload;

    // const dados = {
    // 	cnpjTomador: cnpjEmpresa ? cnpjEmpresa : '',
    // 	chaveNota: formBipe ? formBipe : ''
    // };
    let buscarNotass = [];
    cteMensagem = "Error romaneios";
    yield put(Actions.incluirNotCteSucesso(NotasCte));

    // const response = yield call(buscarNotasRequisicao, dados);

    // if (response.ok) {
    // 	if (response.data.resultado) {
    // 		buscarNotass = response.data.valor;
    // 		yield put(Actions.editarCteSucesso(DadosNotasCte));
    // 	}
    // } else {
    // 	if (response.data.hasOwnProperty('error')) {
    // 		switch (response.data.error) {
    // 			default:
    // 			cteMensagem = 'Não foi possível gerar romaneios [205]';
    // 				break;
    // 		}
    // 	} else {
    // 		cteMensagem = 'Sem dados para exibir';
    // 	}
    // 	// yield put(Actions.setLoadGerarRomaneios({ loader: false }));
    // }

    // yield put(Actions.setLoadGerarRomaneios({ loader: false }));
}

function* pesquisarCte({ payload }) {
    //console.log('chegou->', DadosNotasCte)
    // const { cnpjEmpresa } = payload;

    // const dados = {
    // 	cnpjTomador: cnpjEmpresa ? cnpjEmpresa : '',
    // 	chaveNota: formBipe ? formBipe : ''
    // };

    let buscarNotass = [];
    cteMensagem = "Error romaneios";
    yield put(Actions.pesquisarCteSucesso(PesquisaCte));

    // const response = yield call(buscarNotasRequisicao, dados);

    // if (response.ok) {
    // 	if (response.data.resultado) {
    // 		buscarNotass = response.data.valor;
    // 		yield put(Actions.editarCteSucesso(DadosNotasCte));
    // 	}
    // } else {
    // 	if (response.data.hasOwnProperty('error')) {
    // 		switch (response.data.error) {
    // 			default:
    // 			cteMensagem = 'Não foi possível gerar romaneios [205]';
    // 				break;
    // 		}
    // 	} else {
    // 		cteMensagem = 'Sem dados para exibir';
    // 	}
    // 	// yield put(Actions.setLoadGerarRomaneios({ loader: false }));
    // }

    // yield put(Actions.setLoadGerarRomaneios({ loader: false }));
}

//---------------------------------------------------------

export function* incluirNotCteDados() {
    yield takeLatest(Types.INCLUIR_NOT_CTE, incluirNotCte);
}

export function* editarCteDados() {
    yield takeLatest(Types.EDITAR_CTE, editarCte);
}

export function* buscarNotasDados() {
    yield takeLatest(Types.BUSCAR_NOTAS, buscarNotas);
}

export function* buscarNotasCteDados() {
    yield takeLatest(Types.BUSCAR_NOTAS_CTE, buscarNotasCte);
}

export function* buscarEstadosCteDados() {
    yield takeLatest(Types.BUSCAR_ESTADOS_CTE, buscarEstadosCte);
}

export function* buscarDistribuidorasCteDados() {
    yield takeLatest(Types.BUSCAR_DISTRIBUIDORAS_CTE, buscarDistribuidorasCte);
}

export function* buscarCteDados() {
    yield takeLatest(Types.BUSCAR_CTE, buscarCte);
}

export function* pesquisarCteDados() {
    yield takeLatest(Types.PESQUISAR_CTE, pesquisarCte);
}

export function* buscarDistTranspDados() {
    yield takeLatest(Types.BUSCAR_DIST_TRANSP, buscarDistTransp);
}

export function* listaGerarCteDados() {
    yield takeLatest(Types.LISTA_GERAR_CTE, listaGerarCte);
}

export default function* rootSaga() {
    yield all([
        fork(incluirNotCteDados),
        fork(editarCteDados),
        fork(buscarNotasDados),
        fork(buscarNotasCteDados),
        fork(buscarEstadosCteDados),
        // fork(buscarTransportadorasCteDados),
        fork(buscarDistribuidorasCteDados),
        fork(buscarCteDados),
        fork(buscarDistTranspDados),
        fork(pesquisarCteDados),
        fork(listaGerarCteDados),
    ]);
}
